<template>
  <div class="documents-list">
    <div class="documents-list__title title">
      <div class="title__text">Перечень документов</div>

      <a :href="archiveDownloadLink" class="title__download-all" download>
        <span>Скачать все документы</span>
        <img
          src="../../assets/icons/documents/download.svg"
          alt="download.svg"
        />
      </a>
    </div>

    <div v-if="isLoading" class="contract-history__loader-overlay">
      <img
        class="contract-history__loader-icon"
        src="@icons/bubble-loader.svg"
        width="40"
      />
    </div>

    <template v-else>
      <div
        v-for="(group, key) in documentGroups"
        :key="key"
        class="documents-list__group documents-list-group"
      >
        <div class="documents-list-group__title">{{ key }}</div>
        <div
          v-for="document in group"
          :key="document.id"
          class="documents-list__item documents-list-item"
        >
          <div>
            <div class="documents-list-item__title">
              {{ document.name }}
            </div>
            <div class="documents-list-item__date">
              {{ document.date | localDateLong }}
            </div>
          </div>
          <FileDownloadIcon
            :file-id="document.file.id"
            class="documents-list-item__link"
          />
        </div>
      </div>

      <a
        href="https://1cbo.ru/rates_and_services/offer2/"
        class="documents-list__rules-link"
        target="_blank"
      >
        <span>Правила обслуживания</span>
        <img src="@icons/external-link.svg" alt="external-link.svg" />
      </a>
    </template>
  </div>
</template>

<script>
import property from "lodash-es/property";
import groupBy from "lodash-es/groupBy";

import Vue, { computed } from "vue";

import { useQuery } from "@tanstack/vue-query";

import store from "../../store";

import { API_URL } from "../../utils/constants";

import { InfoService } from "../../services";

import FileDownloadIcon from "../common/FileDownloadIcon.vue";

export default {
  name: "TariffDocuments",

  components: {
    FileDownloadIcon,
  },

  setup() {
    const orgId = computed(
      () => store.getters["Organizations/ActiveOne/getId"]
    );

    const { data: documents, isLoading } = useQuery(
      ["documents", orgId],
      () => InfoService.fetchDocuments(orgId.value),
      {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: false,
        onError: () => {
          Vue.notify({
            type: "error",
            text: "Ошибка при получении списка документов",
          });
        },
      }
    );

    return { documents, isLoading };
  },

  computed: {
    documentGroups() {
      return groupBy(this.documents, "group");
    },

    archiveDownloadLink() {
      return `${API_URL}/file/archive?id=${this.documents
        ?.map(property("file.id"))
        .join()}`;
    },
  },
};
</script>

<style scoped lang="scss">
.documents-list {
  padding: 30px;

  &__title {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__group {
    padding: 14px 0;

    &:not(:last-child) {
      border-bottom: 1px solid $grey-100;
    }

    &:last-child {
      padding-bottom: 0;
    }
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: 17px;
    }
  }

  &__rules-link {
    display: flex;
    margin-top: 15px;

    span {
      margin-right: 7px;
      color: $blue-500;
      font-size: 15px;
    }

    img {
      width: 16px;
    }
  }

  @media (max-width: 1264px) {
    padding: 24px;
  }
}

.title {
  &__text {
    margin-right: 16px;
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: 500;
  }

  &__download-all {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    span {
      margin-right: 7px;
      color: $blue-500;
      font-size: 15px;
    }

    img {
      width: 18px;
    }
  }

  @media (max-width: 960px) {
    &__text {
      font-size: 20px;
    }
  }

  @media (max-width: 600px) {
    &__text {
      font-size: 18px;
    }
  }
}

.documents-list-group {
  &__title {
    margin-bottom: 14px;
    color: $grey-700;
    font-weight: 500;
  }
}

.documents-list-item {
  display: flex;
  justify-content: space-between;

  &__type {
    margin-bottom: 14px;
    color: $grey-600;
    font-weight: 500;
  }

  &__title {
    margin-bottom: 6px;
  }

  &__date {
    color: $grey-600;
    font-size: 12px;
  }

  &__link {
    display: flex;
    width: 40px;
    height: 40px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 12px;
    border-radius: 5px;
    background: $grey-50;
    color: $grey-600;
    transition: $shortest;

    &:hover {
      background: $grey-100;
      color: $grey-700;
    }
  }
}
</style>
